import {Injectable} from '@angular/core';

@Injectable()
export class ImageService {

    /**
     * Function to preview image file
     * @param event
     * @param model as (ngModel) data
     * @param value as key from object
     */
    readUrl(event: any, model: any, value: string) {
        if (event.target.files && event.target.files[0]) {
            let reader = new FileReader();
            reader.onload = (event: any) => {
                model[value] = event.target.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/ImageService.ts